import React, { useState } from "react";
import { Modal, Input } from "antd";
import moment from "moment";
import styles from "./callBack.module.scss";
import Fetch from "../../../../utils/fetch";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../../../config";

const { TextArea } = Input;

const CallBack = props => {
  const [isCallBackModalVisible, setCallBackModalVisible] = useState(false);
  const [reason, setCallBackReason] = useState("");
  const [showCallBackConfirmation, setCallBackConfirmation] = useState(false);

  const { booking, busDetails } = props;

  const openCallBack = () => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("request_callback_clicked", {
      trip_id: booking.tripId,
      pnr: booking.bookingCode,
      bus_rc: busDetails,
      mobile_no: booking.mobileNo,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      service_name: booking.trip.service.name,
      to_station: booking.dropPoint.address,
      demand_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type: "MAXX"
    });
    setCallBackModalVisible(true);
  };
  const sendEmail = async () => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Callback Requested", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      bus_rc: busDetails,
      service_name: booking.trip.service.name,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type: "MAXX"
    });

    setCallBackModalVisible(false);

    const body = {
      PNR: booking.bookingCode,
      Trip: booking.trip.service.name,
      "Pickup Time": moment(booking.boardingPoint.time).format("lll"),
      "Pickup Station": booking.boardingPoint.name,
      "From City": booking.boardingPoint.city,
      "To City": booking.dropPoint.city,
      "Request Reason": reason
    };
    const options = {
      method: "post",
      data: {
        body
      }
    };
    await Fetch("/user/sendEmail", options);
    setCallBackConfirmation(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div onClick={openCallBack} className={styles.maxcalls}>
          <div>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/callback.svg"
              alt="callback"
            />
            <div>
              <span>Request Callback</span>
              <span>Get callback in 5 mins</span>
            </div>
          </div>
          <div>
            <span>Request Callback</span>
          </div>
        </div>
      </div>
      {isCallBackModalVisible ? (
        <div className={styles.fullscreen}>
          <div className={styles.callBackModal}>
            <div>
              <span>How can we help you?</span>
              <span onClick={() => setCallBackModalVisible(false)}>X</span>
            </div>
            <div>
              <span>Reason for requesting callback</span>
              <TextArea
                placeholder="Type Reason here (optional)"
                className="mb-1"
                autoSize={{ minRows: 4, maxRows: 4 }}
                onChange={e => setCallBackReason(e.target.value)}
              />{" "}
            </div>
            <div>
              <button onClick={sendEmail}>Request Callback</button>
            </div>
          </div>
        </div>
      ) : null}
      {showCallBackConfirmation ? (
        <Modal
          centered
          width={"100%"}
          visible={showCallBackConfirmation}
          footer={null}
          closable={false}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <div className={styles.confirmationCallBackModal}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/max/check.svg"
              alt="done"
            />
            <p>Callback Request Successfully Registered</p>
            <span>Our team will call you within the next 5 minutes</span>
            <button onClick={() => setCallBackConfirmation(false)}>
              Okay, Got It
            </button>
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

export default CallBack;
